import React from 'react'
import { useIntl } from 'react-intl'
import { FieldType } from '@molecules/Field/Field.types'

export const getAccountDataSharingConfig = (
  config: {
    c_aboAlerts: boolean
    c_decalcifyAlerts: boolean
    c_newsletter: boolean
  },
  newsletterLabel: React.ReactNode
) => {
  const { formatMessage } = useIntl()

  return {
    aboAlerts: {
      id: 'aboAlerts',
      name: 'aboAlerts',
      type: 'checkbox' as FieldType,
      label: formatMessage({
        id: 'msp.account.datasharing.aboAlerts',
        defaultMessage:
          'I would like to receive an email reminder before my subscription orders are dispatched.'
      }),
      defaultValue: config.c_aboAlerts
    },
    decalcifyAlerts: {
      id: 'decalcifyAlerts',
      name: 'decalcifyAlerts',
      type: 'checkbox' as FieldType,
      label: formatMessage({
        id: 'msp.account.datasharing.decalcifyAlerts',
        defaultMessage:
          'I would like to receive an email reminder when the machine is due to be descaled.'
      }),
      defaultValue: config.c_decalcifyAlerts
    },
    newsletter: {
      id: 'newsletter',
      name: 'newsletter',
      type: 'checkbox' as FieldType,
      label: newsletterLabel,
      defaultValue: config.c_newsletter
    }
  }
}
